import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiEye } from 'react-icons/fi';
import { useSettings } from '../context/SettingsContext';
import ProductReviewStars from './ProductReviewStars';
import styles from './bodywon.module.css';

const ProductCard = ({ product, onAddToCart, variant = 'default', textAlign = 'center' }) => {
  const { formatPrice } = useSettings();
  const colors = product.colors || [];
  const [activeColor, setActiveColor] = useState(colors[0] || null);

  useEffect(() => {
    setActiveColor(colors[0] || null);
  }, [product.id, colors]);

  const handleQuickAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onAddToCart(product);
  };

  if (variant === 'minimalist') {
    return (
      <Link to={`/product/${product.id}`} className={styles.minimalistCard}>
        <div className={styles.minimalistHeader}>
          <span style={{ whiteSpace: 'pre-wrap' }}>{product.name.replace('\n', ' ')}</span>
          <FiEye className={styles.wishlistIcon} />
        </div>
        <div className={styles.minimalistImageContainer}>
          <img
            src={product.imageSrc}
            alt={product.name}
            style={{ width: '100%', height: '100%', objectFit: 'contain', padding: '0 1rem' }}
          />
        </div>
        <div className={styles.minimalistFooter}>
          <div className={styles.minimalistPrice}>
            {product.originalPrice ? (
              <>
                <span className={styles.originalPrice}>{formatPrice(product.originalPrice, 0)}</span>
                <span>{formatPrice(product.price, 0)}</span>
              </>
            ) : (
              <span>{formatPrice(product.price, 0)}</span>
            )}
          </div>
          <button className={styles.minimalistAddToCart} onClick={handleQuickAdd}>
            QUICK ADD
          </button>
        </div>
      </Link>
    );
  }

  return (
    <div className={styles.featureCard}>
      <Link to={`/product/${product.id}`} className={styles.featureCardNavLink}>
        <div className={styles.featureImageContainer}>
          <img
            src={product.imageSrc}
            alt={product.name}
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
          />
          <div className={styles.quickViewIcon}><FiEye /></div>
          <div className={styles.quickAddButton} onClick={handleQuickAdd}>
            QUICK ADD
          </div>
        </div>
      </Link>

      <div className={`${styles.featureInfo} ${textAlign === 'left' ? styles.alignLeft : ''}`}>
        <Link to={`/product/${product.id}`} className={styles.featureNameLink}>
          <p className={styles.featureName} style={{ whiteSpace: 'pre-wrap' }}>{product.name}</p>
        </Link>
        <ProductReviewStars product={product} variant="card" />
        <div className={styles.featurePrices}>
          {product.originalPrice ? (
            <>
              <span className={styles.originalPrice}>{formatPrice(product.originalPrice)}</span>
              <span className={styles.salePrice}>{formatPrice(product.price)}</span>
            </>
          ) : (
            <span className={styles.regularPrice}>{formatPrice(product.price)}</span>
          )}
        </div>
        <div className={styles.featureColors}>
          {colors.map(swatch => (
            <button
              key={swatch.value}
              className={`${styles.colorSwatch} ${activeColor?.value === swatch.value ? styles.active : ''}`}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setActiveColor(swatch);
              }}
            >
              {swatch.type === 'color' ? (
                <span style={{ backgroundColor: swatch.value }}></span>
              ) : (
                <img src={swatch.value} alt="color swatch" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
